/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CandidateAuthRequestRequest, CandidateAuthRequestResponse } from '../types/CandidateAuthRequest'

/**
 * POST /candidate-center/login/request
 * @see backend/nexus/modules/CandidateCenter/Http/Controllers/CandidateAuthController.php CandidateAuthController::request
 */
export async function candidateAuthRequest(
	data: CandidateAuthRequestRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateAuthRequestResponse>> {
	return axiosInstance.post('/candidate-center/login/request', data, config)
}
